module.exports = __webpack_public_path__ + "static/media/nextia_black.e5169dc6.png";